import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowActivityPreviewRequest,
  WorkflowActivityPreviewResponse,
  WorkflowTaskActivityActionRequest,
  WorkflowTaskActivityActionResponse
} from '../models/workflow-activity-action.model';

@Injectable({ providedIn: 'root' })
export class WorkflowActivityActionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-actions`;

  constructor(private http: HttpClient) {}

  test(request: WorkflowTaskActivityActionRequest): Observable<WorkflowTaskActivityActionResponse> {
    return this.http.post<WorkflowTaskActivityActionResponse>(
      `${this.apiUrl}/activity/test`,
      request
    );
  }

  preview(request: WorkflowActivityPreviewRequest): Observable<WorkflowActivityPreviewResponse> {
    return this.http.post<WorkflowActivityPreviewResponse>(
      `${this.apiUrl}/activity/preview`,
      request
    );
  }
}
